export default {
  name: 'smart-suggestions',
  translationKey: 'smart-suggestions-module',
  routePrefix: 'smart-suggestions',
  routeNamePrefix: 'admin.smart-suggestions',
  directRoutesAvailable: false,
}
